(function() {
    'use strict';

    angular.module('product')
        .controller('ProductParameterOptionCreateController', ProductParameterOptionCreateController);

    ProductParameterOptionCreateController.$inject = ['$uibModalInstance'];

    function ProductParameterOptionCreateController($uibModalInstance) {
        var self = this;

        self.optionData = {
            'name_pl': '',
            'name_en': '',
            'name_de': '',
            'name_cpen': '',
            'name_cpde': ''
        };
        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            $uibModalInstance.close(self.optionData);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
